import { directiveSettings } from '../../utils/parse';
import { onScroll, getScrollTop } from '../../utils/window';
import {frame} from '../../utils/drawing';
import { isTouch } from '../../utils/inspection';
/**
 * @module directives/scroll/reveal
 */

/**
 * Reveals elements on scroll.
 */
export default function revealDirective() {
  const revealers = document.querySelectorAll('[data-sw-reveal]');

  // only setup if not a touchscreen
  if (!isTouch()) {

    // reveal check
    const checkForReveal = (element, reset = false) => {
      const top = getScrollTop(),
      scrolled = (top + window.innerHeight) > element.offsetTop;
      if (scrolled && !element.classList.contains('is-revealed')) {
        element.classList.add('is-revealed');
      } else if (reset && !scrolled && element.classList.contains('is-revealed')) {
        element.classList.remove('is-revealed');
      }
    }

    // hook up all scroll reveal elements
    revealers.forEach(element => {
      const data = element.getAttribute('data-sw-reveal'),
      settings = directiveSettings(data, {
        force: false,
        reset: true,
      }, 'force');

      if (!settings.force) element.style.transition = 'none';

      checkForReveal(element, settings.reset);

      if (!settings.force) frame(_ => { element.style.transition = '' });
      onScroll(_ => checkForReveal(element, settings.reset));
    });

  } else {

    // on touchscreens just reveal everything
    revealers.forEach(element => {
      element.style.transition = 'none';
      element.classList.add('is-revealed');
    });
  }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/reveal.js